// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"nD","contentFrame":"nE","buttonGroup":"nF","button":"nG","header":"nH","text":"nI","contentImage":"nJ","closeButton":"nK"};